module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Example', {
    attrs: {
      "component": _vm.ExSimple,
      "code": _vm.ExSimpleCode
    }
  }), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExComponent,
      "code": _vm.ExComponentCode,
      "title": "Component"
    }
  }, [_c('p', [_vm._v("\n                A modal with a component. When you want to close the Modal, call the 'close' method —\n                "), _c('code', [_vm._v("this.$parent.close()")]), _vm._v(" — from the injected component.\n            ")]), _vm._v(" "), _c('p', [_c('code', [_vm._v("trap-focus")]), _vm._v(" prop could be useful in this case.\n            ")])]), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExProgrammatic,
      "code": _vm.ExProgrammaticCode,
      "title": "Programmatic"
    }
  }, [_c('p', [_vm._v("Syntax:")]), _vm._v(" "), _c('CodeView', {
    attrs: {
      "lang": "javascript",
      "code": _vm._f("pre")(_vm.programmaticSyntax),
      "expanded": ""
    }
  })], 1), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExFullScreen,
      "code": _vm.ExFullScreenCode,
      "title": "Full Screen"
    }
  }, [_c('div', {
    staticClass: "tags has-addons"
  }, [_c('span', {
    staticClass: "tag is-success"
  }, [_vm._v("New!")]), _vm._v(" "), _c('span', {
    staticClass: "tag is-info"
  }, [_vm._v("0.7.8")])]), _vm._v(" "), _c('p', [_vm._v("Add the "), _c('code', [_vm._v("full-screen")]), _vm._v(" prop to cover the whole page.")])]), _vm._v(" "), _c('ApiView', {
    attrs: {
      "data": _vm.api
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9047446e"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./docs/pages/components/modal/Modal.vue
// module id = 1440
// module chunks = 26